import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Error handling interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('API error:', error);
        return Promise.reject(error);
    }
);

export const portfolioAPI = {
    // Get all projects
    getProjects: async (skip = 0, limit = 50) => {
        try {
            const response = await api.get('/portfolio/projects', {
                params: { skip, limit },
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching projects:', error);
            throw error;
        }
    },

    // Get portfolio statistics
    getStats: async () => {
        try {
            const response = await api.get('/portfolio/stats');
            return response.data;
        } catch (error) {
            console.error('Error fetching stats:', error);
            throw error;
        }
    },

    // Manually trigger refresh
    refreshProjects: async () => {
        try {
            const response = await api.post('/portfolio/refresh');
            return response.data;
        } catch (error) {
            console.error('Error refreshing projects:', error);
            throw error;
        }
    },
};

export const contactAPI = {
    // Submit contact form
    submitContact: async (formData) => {
        try {
            const response = await api.post('/contact', formData);
            return response.data;
        } catch (error) {
            console.error('Error submitting contact form:', error);
            throw error;
        }
    },
};

export default api;
